import axios from "axios";

const ZAPPING_MENU_CLASSNAME = "js-zapping-menu";
const $zappingMenuElementList = document.querySelectorAll(`.${ZAPPING_MENU_CLASSNAME}`);

const triggerApi = (createZappingMenuByWorkTitleIdSessionApiPath) => {
  axios({
    method: "GET",
    url: createZappingMenuByWorkTitleIdSessionApiPath,
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  });
};

$zappingMenuElementList.forEach(function (element) {
  element.addEventListener("click", () => {
    const { createZappingMenuByWorkTitleIdSessionApiPath } = element.dataset;
    triggerApi(createZappingMenuByWorkTitleIdSessionApiPath);
  });
});
